export function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
    return null;
}

// Build version for client version tracking
const BUILD_VERSION =
    typeof __BUILD_VERSION__ !== "undefined" ? __BUILD_VERSION__ : "dev";

export async function fetchWithCSRF(
    input: RequestInfo,
    init?: RequestInit,
): Promise<Response> {
    const csrfToken = getCookie("csrftoken");
    // Determine if this is a state-changing request:
    const method = init?.method ? init.method.toUpperCase() : "GET";
    const stateChangingMethods = ["POST", "PUT", "PATCH", "DELETE"];

    // Create headers object; merge if provided.
    const headers = new Headers(init?.headers);
    if (stateChangingMethods.includes(method)) {
        headers.set("X-CSRFToken", csrfToken || "");
    }

    // Always send the client version header
    headers.set("X-Client-Version", BUILD_VERSION);

    const response = await fetch(input, {
        ...init,
        headers,
        credentials: "include", // Ensure cookies are sent
    });

    // Check for version mismatch in response headers
    const isOutdated = response.headers.get("X-Client-Outdated");
    const currentVersion = response.headers.get("X-Current-Version");

    console.debug("[fetchWithCSRF] Checking version headers:", {
        isOutdated,
        currentVersion,
        BUILD_VERSION,
    });

    if (isOutdated === "true" && currentVersion) {
        console.debug("[fetchWithCSRF] Dispatching client-outdated event");
        // Dispatch custom event that useClientVersion hook is listening for
        window.dispatchEvent(
            new CustomEvent("client-outdated", {
                detail: { version: currentVersion },
            }),
        );
    }

    return response;
}
